/**
 * TemplateOptions object generated by Goal app.
 *
 * @typedef {Object} TemplateOptions
 * @namespace
 *
 * @memberof module:Goal.Model.Entity
 *
 * @property {String} type The template type.
 * @property {String} orientation The template orientation (Vertical|Horizontal)
 * @property {String} milestoneSize The sizing of milestones (equal|proportional|highlight)
 */
class TemplateOptions {

	constructor(type, orientation, milestoneSize) {

		this.type = type;
		this.orientation = orientation;
		this.milestoneSize = milestoneSize;
	}
}

export default TemplateOptions;